import script from "./VTableNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./VTableNumber.vue?vue&type=script&setup=true&lang=js"

import "./VTableNumber.vue?vue&type=style&index=0&id=01971449&scoped=true&lang=less"

import exportComponent from "D:\\cwzl\\cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01971449"]])

export default __exports__